<div class="container-fluid py-3">
  <h4 class="mb-3">EDR Analytics</h4>

  <div class="mb-4">
    <app-hud
      [threats]="threats()"
      [threatReboot]="threatReboot()"
      [outdatedAgents]="outdatedAgents()"
      [coverage]="coverage()"
      [organizationId]="organizationId()"
      [dateRange]="selectedDateRange()"
      [threatsLoading]="threatsLoading()"
      [threatRebootLoading]="threatRebootLoading()"
      [outdatedAgentsLoading]="outdatedAgentsLoading()"
      [coverageLoading]="coverageLoading()"
      (refresh)="refreshHudData()"
    ></app-hud>
  </div>

  <div class="row g-3 mb-3">
    <div class="col-lg-12">
      <app-cyflare-period
        [(dateRange)]="selectedDateRange"
        label="Filter EDR Analytics:"
        (dateRangeChange)="applyFilter($event)"
      ></app-cyflare-period>
    </div>
  </div>

  <div class="row g-3">
    <div class="col-lg-6 col-md-12">
      <app-agent-status
        [status]="status()"
        [organizationId]="organizationId()"
        [dateRange]="selectedDateRange()"
        [isLoading]="agentStatusLoading()"
      ></app-agent-status>
    </div>
    <div class="col-lg-6 col-md-12">
      <app-threat-status
        [threatStatus]="threatStatus()"
        [organizationId]="organizationId()"
        [dateRange]="selectedDateRange()"
        [isLoading]="threatStatusLoading()"
      ></app-threat-status>
    </div>
  </div>
</div>
